import React, { Component } from 'react';
import { Select, Radio } from 'antd';
import SymbolText from './SymbolText'
import Field from './Field';

const { Option } = Select;
const RadioGroup = Radio.Group;

class InvestigationByStage extends Component {
    handleChange = (value, key) => {
        const { data, index, onChange } = this.props
        switch(key) {
            case 'responsibleFieldId':
                const { symbol, id } = data;
                onChange({
                    id,
                    symbol,
                    responsibleFieldId: value,
                }, index);
                return;
            case 'byStageId':
                data[key] = value ? value.join(',') : '';
                data.investigationMedicineType = '';
                break;
            case 'range':
                data[key] = value;
                data.investigationMedicineType = '';
                break;
            case 'investigationMedicineType':
                data[key] = value ? value.join(',') : '';
                break;
            default:
                data[key] = value;
                break;
        }
        onChange(data, index);
    }

    render() {
        const { data, fieldList, byStageList, rangeList, medicineTypeList } = this.props;
        const { symbol, responsibleFieldId, byStageId, range, investigationMedicineType } = data;
        const byStageOption = byStageList.map(i => <Option key={i.projectStagingId}>{i.projectStagingName}</Option>);
        const medicineTypeOption = medicineTypeList.map(d => <Option key={d.researchProductTypeId} title={d.researchProductTypeName}>{d.researchProductTypeName}</Option>);
        const rangeOption = rangeList.map(i => <Radio key={i.projectStagingTypeId} value={i.projectStagingTypeId}>{i.projectStagingTypeName}</Radio>);
        return (
            <div>
                <SymbolText symbol={symbol} />
                <div className="border">
                    <div>
                        <Field value={responsibleFieldId} list={fieldList} onChange={this.handleChange} />
                        <span style={{ margin: '0 10px' }}>=</span>
                        <Select
                            value={byStageId ? byStageId.split(',') : []}
                            placeholder="请选择"
                            mode="multiple"
                            style={{ width: 240 }}
                            onChange={(value) => this.handleChange(value, 'byStageId')}
                        >
                            {byStageOption}
                        </Select>
                    </div>
                    <div style={{ marginTop: 10 }}>
                        <RadioGroup onChange={(e) => this.handleChange(e.target.value, 'range')} value={range}>
                            {rangeOption}
                        </RadioGroup>
                    </div>
                    {
                        range == 2 &&
                        <div style={{ marginTop: 10 }}>
                            <div style={{display: 'inline-block', width: 160, textAlign: 'right'}}>研究产品类型</div>
                            <span style={{ margin: '0 10px' }}>=</span>
                            <Select
                                value={investigationMedicineType ? investigationMedicineType.split(',') : []}
                                placeholder="请选择"
                                mode="multiple"
                                style={{ width: 240 }}
                                onChange={(value) => this.handleChange(value, 'investigationMedicineType')}
                            >
                                {medicineTypeOption}
                            </Select>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default InvestigationByStage;


// WEBPACK FOOTER //
// ./src/components/user/fieldLeader/components/InvestigationByStage.js